/** Product branding — keep in sync with backend defaults (ApplicationSettings.appName). */
export const APP_BRAND = {
  name: 'u-comm',
  defaultAppName: 'u-comm',
} as const;

const LEGACY_APP_NAMES = new Set(['UMS Application', 'UMS', 'Communication System']);

/** Normalize app name from API/DB; legacy values fall back to the default brand. */
export function normalizeAppName(name?: string | null): string {
  const trimmed = name?.trim();
  if (!trimmed || LEGACY_APP_NAMES.has(trimmed)) {
    return APP_BRAND.defaultAppName;
  }
  return trimmed;
}
